module.exports = __webpack_public_path__ + "img/caracteristiques-v2.161df5a2.png";